import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { Add as SENDER_ADD } from 'Components/Api/KYCPPIAPI';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Paper, Button, Typography, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SenderRegistration = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const ActiveDMTName = location?.state?.ActiveDMTName;
    const Mobile = location?.state?.Mobile;
    const Name = location?.state?.Name;
    const PinCode = location?.state?.Pincode;
    const Address = location?.state?.Address;
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        Address: ''
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        setIsError(false);

        let jsonObj = {
            Mobile: Mobile,
            SenderMobile: Mobile,
            Name: Name,
            PinCode: PinCode,
            Address: Address,
            DMTName: ActiveDMTName,
            IsKYC: true
        };

        var response = await SENDER_ADD(JSON.stringify(jsonObj));

        if (!response.isAuthorized) {
            LOGOUT();
        }

        setLoading(false);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        if (response.data === 'Please verify sender OTP') {
            var param = {
                Mobile: values.Mobile,
                ActiveDMTName: ActiveDMTName
            };
            history.push('/KYCPPI_SenderVerify', param);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        var param_2 = {
            Mobile: values.Mobile,
            DMTName: ActiveDMTName
        };

        history.push('/KYCPPI_SenderSearch', param_2);
    };

    const select = () => {
        setFormObject({
            ...formObject,
            Name: '',
            Address: ''
        });
    };

    useEffect(() => {
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        // Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'), 
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                            style={{ justifyContent: 'center' }}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Sender Add
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>

                                                <Grid item xs={12}>
                                                    {Mobile ? (
                                                        <Typography variant="body1" style={{ marginBottom: '0.5rem' }}>
                                                            Mobile: {Mobile}
                                                        </Typography>
                                                    ) : (
                                                        <TextField
                                                            variant="outlined"
                                                            label="Mobile"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                    )}
                                                </Grid>

                                                <Grid item xs={12}>
                                                    {Name ? (
                                                        <Typography variant="body1" style={{ marginBottom: '0.5rem' }}>
                                                            Name: {Name}
                                                        </Typography>
                                                    ) : (
                                                        <TextField
                                                            variant="outlined"
                                                            label="Name"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                    )}
                                                </Grid>

                                                <Grid item xs={12}>
                                                    {PinCode ? (
                                                        <Typography variant="body1" style={{ marginBottom: '0.5rem' }}>
                                                            Pincode: {PinCode}
                                                        </Typography>
                                                    ) : (
                                                        <TextField
                                                            variant="outlined"
                                                            label="Pincode"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                    )}
                                                </Grid>

                                                <Grid item xs={12}>
                                                    {Address ? (
                                                        <Typography variant="body1" style={{ marginBottom: '0.5rem' }}>
                                                            Address: {Address}
                                                        </Typography>
                                                    ) : (
                                                        <TextField
                                                            variant="outlined"
                                                            label="Address"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                    )}
                                                </Grid>

                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Add"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>

                                            <Button
                                                type="reset"
                                                title="Cancel"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                                onClick={(e) => {
                                                    var param_2 = {
                                                        Mobile: values.Mobile,
                                                        DMTName: ActiveDMTName
                                                    };

                                                    history.push(
                                                        '/KYCPPI_SenderSearch',
                                                        param_2
                                                    );
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </CustomContainer>
    );
};
